import { style, trigger, state, animate, transition } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('displayState', [
      // state('false', style({ overflow: 'hidden', height: '0px'})),
      // state('true', style({ overflow: 'hidden', height: '*'})),
      // transition('false => true', animate('200ms cubic-bezier(0.68, -0.55, 0.265, 1.55)')),
      // transition('true => false', animate('200ms cubic-bezier(0.68, -0.55, 0.265, 1.55)'))
    ]),
  ]
})
export class HomeComponent implements OnInit {

  isLoading: boolean = true;
  display = false;
  constructor() {
    this.isLoading = true;
    this.display = false;
    setTimeout( () => this.isLoading = false, 1000);
    setTimeout( () => this.display = true, 1100);
   }
   options: AnimationOptions = {
    path:'assets/home/preloading-lottie.json'
  }

  ngOnInit(): void {
  }

}
